export default __webpack_public_path__ + "static/home_bodegon_argentina-5ae181778bbe9e7f5c51c1d48852d5ee.png";